(function(root, factory) {
    if (typeof define === 'function' && define.amd) {
        // AMD. Register as an anonymous module.
        define('app',['underscore', 'i18n!nls/messages'], function(_, messages) {
            // Also create a global in case some scripts
            // that are loaded still are looking for
            // a global even when an AMD loader is in use.
            return (root.App = factory(_, messages));
        });
    } else {
        // Browser globals
        root.App = factory(_, {messages:{}});
    }
}(this, function(_, messages) {

    _.mixin({
        localize: function(string) {
            if (messages.messages && messages.messages[string]) {
                return messages.messages[string];
            }
            return string;
        }
    });

    return {

        Models: {},
        Collections: {},
        Views: {},

        data: {},
        router: null,
        appView: null,

        staticUrl: function(url) {
            return "/static/" + url;
        },

        shouldUseCORSForApiRequests: function() {
            return false;
        },

        /**
         * Method to prefix urls, mostly API urls, with SiteBooster domain.
         *
         * For SiteBooster itself, the url will be passed through as is.
         *
         * But for Business Data Index, the url will be prefixed with SiteBooster domain to send cross-domain.
         * In this case make sure that the request supports CORS.
         *
         * @param {String} url
         * @returns {String}
         */
        absoluteSiteBoosterUrl: function(url) {
            return url;
        }

    };

}));

